import React from "react";
import EditButtonConfig from "./EditButtonConfig";

const EditFormBlock = ({
  editElementData,
  setEditElementData,
  elements,
  device,
  tableID,
  places,
  flag = false,
  handleClasses,
  type = "statemachine"
}) => {
  const obj = {
    id: editElementData.id,
    device: device,
    type: "button",
    config: editElementData.config,
    elements: elements
  };

  const handleSaveFromConfig = (config) => {
    setEditElementData({ ...editElementData, config: config });
  };

  return (
    <EditButtonConfig
      editElementRightsidebar={obj}
      onSave={handleSaveFromConfig}
      places={places}
      device={device}
      smId={tableID}
      flag={flag}
      handleClasses={handleClasses}
      type={type}
    />
  );
};

export default EditFormBlock;
